<template>
  <section>
    <div v-if="loading">
      <HoursTasksComponent
        v-if="this.$route.path !== '/admin/pendings-tasks'"
        :team_session="team_session"
        :account_session="account_session"
      />

      <!-- Edit -->
      <TaskEditModal
        v-if="boxedit && task_current"
        :users="users"
        :states="states"
        :defineQuery="defineQuery"
        :usersession="usersession"
        :team_session="team_session"
        :task_current="task_current"
        @taskEdited="taskEdited"
        @closeEditTask="closeEditTask()"
      />
      <!-- END: Edit -->

      <!-- Filter -->
      <div v-if="this.$route.path !== '/admin/pendings-tasks'">
        <div
          class="intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
        >
          <h2 class="intro-y text-lg font-medium mr-auto mt-8">
            Tareas <app-title-custom v-if="account_session" /> ({{
              filteredTasks.length
            }})
          </h2>
          <div
            v-if="tasks_by_finish > 0"
            :class="[
              clic_taskspendingauth
                ? 'border-theme-1 text-theme-1'
                : 'border-theme-6 text-theme-6',
            ]"
            class="rounded-md flex items-center px-5 py-2 mt-2 mb-2 border cursor-pointer"
            @click="taskPendingAuth()"
          >
            {{
              clic_taskspendingauth
                ? 'Ver todas las tareas'
                : `Ver ${tasks_by_finish} tarea(s) pendiente(s) por finalizar.`
            }}
          </div>
        </div>
        <div
          class="intro-y flex flex-col-reverse mt-2 sm:flex-row items-center"
        >
          <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
            <app-icon
              name="search"
              classname="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700"
            />
            <input
              type="text"
              class="input w-full sm:w-64 box px-10 text-gray-700"
              placeholder="Buscar por nombre"
              v-model="filter.name"
            />
            <div
              class="inbox-filter dropdown hidden md:block md:absolute inset-y-0 mr-3 right-0 flex items-center"
            >
              <app-icon
                name="chevron-down"
                classname="dropdown-toggle w-4 h-4 mt-3 cursor-pointer text-gray-700"
              />
              <div
                class="inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
              >
                <div class="dropdown-box__content box p-5">
                  <div class="grid grid-cols-12 gap-4 row-gap-3">
                    <div class="col-span-6">
                      <div class="text-xs">Estado</div>
                      <select
                        class="input w-full border mt-2 flex-13"
                        v-model="filter.state"
                        required
                      >
                        <option :value="null">Seleccione una opción</option>
                        <option
                          v-for="state in states"
                          :value="state.id"
                          v-if="state.id != 5"
                        >
                          {{ state.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-span-6">
                      <div class="text-xs">Fecha entrega</div>
                      <div
                        class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
                      >
                        <input
                          type="date"
                          class="input w-full border mt-2 flex-1"
                          v-model="filter.date"
                        />
                      </div>
                    </div>
                    <div class="col-span-6">
                      <div class="text-xs">Codigo</div>
                      <input
                        type="text"
                        class="input w-full border mt-2 flex-1"
                        placeholder="Buscar por codigo"
                        v-model="filter.slug"
                      />
                    </div>
                    <div class="col-span-6">
                      <div class="text-xs">Creada por</div>
                      <select
                        class="input w-full border mt-2 flex-1"
                        v-model="filter.created_by"
                        required
                      >
                        <option value="null">Seleccione un usuario</option>
                        <option v-for="user in filteredUsers" :value="user.id">
                          {{ user.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-span-6">
                      <div class="text-xs">
                        Desde <span>(Fecha creación)</span>
                      </div>
                      <input
                        type="date"
                        class="input w-full border mt-2 flex-1"
                        v-model="filter.start_date"
                      />
                    </div>
                    <div class="col-span-6">
                      <div class="text-xs">
                        Hasta <span>(Fecha creación)</span>
                      </div>
                      <input
                        type="date"
                        class="input w-full border mt-2 flex-1"
                        v-model="filter.end_date"
                      />
                    </div>
                    <div class="col-span-6">
                      <div class="w-full sm:w-auto flex">
                        <button
                          @click="filter = clearFilter()"
                          class="button mt-28 text-white bg-theme-1 shadow-md mr-2"
                        >
                          Borrar Filtro
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="intro-y w-full mt-2 mb-4 flex sm:flex-row items-center">
            <div
              class="w-full hidden md:block sm:w-auto relative mr-auto mt-3 sm:mt-0"
            ></div>
            <div
              class="w-full sm:w-auto flex items-center sm:ml-auto mt-0 sm:mt-0"
            >
              <button
                @click="viewTaskFinish()"
                class="button button--sm mr-1 mb-1 mt-1"
                v-if="account_session"
                :class="
                  completed_tasks
                    ? 'bg-theme-1 text-white'
                    : 'border border-theme-1 border-theme-10 text-theme-10'
                "
              >
                {{
                  completed_tasks
                    ? 'Quitar tareas finalizadas'
                    : 'Ver tareas finalizadas'
                }}
              </button>
            </div>
            <div class="w-full sm:w-auto flex">
              <button
                @click="setCreateTaskModal(true)"
                class="button text-white bg-theme-1 shadow-md mr-2"
              >
                Crear tarea
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="intro-y flex flex-col-reverse mt-10 sm:flex-row items-center"
        v-else
      >
        <h2 class="intro-y text-lg font-medium mr-auto mt-8">
          Tareas Pendientes
          <app-title-custom v-if="account_session" />
          ({{ filteredTasks.length }})
        </h2>
        <div class="w-full sm:w-auto flex items-center sm:ml-auto mt-0 sm:mt-0">
          <button
            v-if="account_session"
            @click="viewAccounts('all')"
            class="button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10"
          >
            Ver todas las cuentas
          </button>
          <button
            v-else
            @click="viewAccounts('one')"
            class="button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10"
          >
            Ver solo una cuenta
          </button>
          <button
            @click="removeSupport()"
            class="button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10"
            v-if="usersession.team_id == 1"
          >
            {{ filter.support ? 'Quitar' : 'Agregar' }} Tareas de Soporte
          </button>
          <button
            @click="assignedToMe()"
            class="button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10"
          >
            {{
              filter.assigned_to_me
                ? 'Ver todas las tareas'
                : 'Ver mis asignadas'
            }}
          </button>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="whitespace-no-wrap">NOMBRE</th>
              <th class="text-center whitespace-no-wrap">PROYECTO</th>
              <th class="text-center whitespace-no-wrap">ESTADO</th>
              <th class="text-center whitespace-no-wrap">FECHA ENTREGA</th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr class="intro-x zindex-0" v-for="task in filteredTasks">
              <td>
                <a
                  class="font-medium whitespace-no-wrap flex"
                  @click="
                    task.campaign_attribute.project_account_id ==
                    auth_session_account
                      ? editTask(task)
                      : viewAccountTask(task)
                  "
                  role="button"
                >
                  <app-icon
                    v-if="task.path"
                    name="link"
                    classname="w-4 h-3 mt-1 mr-1"
                  />
                  {{ task.name.toUpperCase() | limit }}
                </a>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ task.slug }}
                </div>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ task.created_at }}
                </div>
              </td>
              <td class="text-center w-40">
                <div
                  class="text-center text-xs"
                  :class="[
                    task.campaign_attribute.project_hours > 1 &&
                    task.team_id == 1
                      ? 'text-theme-1 font-bold'
                      : '',
                  ]"
                >
                  {{ task.campaign_attribute.project_name }}
                </div>
                <div class="text-center text-xs">
                  {{ task.campaign_attribute.project_account_name }} -
                  {{ task.campaign_attribute.project_account_country_prefix }}
                </div>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ task.campaign_attribute.name }}
                </div>
              </td>
              <td class="w-40">
                <div class="flex items-center justify-center">
                  <template v-for="user in users">
                    <div
                      class="w-10 h-10 image-fit zoom-in"
                      v-if="task.created_by === user.id"
                      :key="`user-created_by-${user.id}`"
                    >
                      <img
                        :alt="task.user_created_name"
                        class="tooltip rounded-full tooltipstered"
                        :src="
                          user.avatar
                            ? user.avatar
                            : `/static/images/profile.png`
                        "
                        :title="task.user_created_name"
                      />
                    </div>
                  </template>
                  <template v-for="user in users">
                    <div
                      class="w-10 h-10 image-fit zoom-in -ml-5"
                      v-if="task.user_id === user.id"
                      :key="`user-user_id-${user.id}`"
                    >
                      <img
                        :alt="task.user_name"
                        class="tooltip rounded-full tooltipstered"
                        :src="
                          user.avatar
                            ? user.avatar
                            : `/static/images/profile.png`
                        "
                        :title="task.user_name"
                      />
                    </div>
                  </template>
                </div>
                <div class="flex items-center justify-center">
                  {{ task.state_name }} - {{ task.hours }}hs
                </div>
              </td>
              <td class="text-center">
                <button
                  class="button button--sm w-24 text-white"
                  :class="dateClass(task)"
                >
                  {{ task.date }}
                </button>
              </td>
              <td class="table-report__action">
                <div
                  class="flex justify-center items-center"
                  v-if="
                    task.campaign_attribute.project_account_id ==
                    auth_session_account
                  "
                >
                  <a
                    @click="editTask(task)"
                    class="cursor-pointer flex items-center mr-3"
                    v-if="task.state_id != 4"
                  >
                    <app-icon name="edit" classname="w-4 h-4 mr-2" /> Editar
                  </a>
                  <a
                    @click="viewTask(task)"
                    class="cursor-pointer flex items-center mr-3"
                    v-else
                  >
                    <app-icon name="eye" classname="w-5 h-5 mr-2" /> Ver
                  </a>
                  <a
                    @click="createDuplicateModal(task)"
                    class="cursor-pointer flex items-center mr-3"
                  >
                    <app-icon name="duplicate" classname="w-4 h-4 mr-2" />
                    Duplicar
                  </a>
                </div>
                <div class="flex justify-center items-center" v-else>
                  <a
                    @click="viewAccountTask(task)"
                    class="cursor-pointer flex items-center mr-3"
                  >
                    <app-icon name="folder" classname="w-4 h-4 mr-2" /> Editar
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->
    </div>

    <app-loading v-else />

    <CreateTaskModal
      v-if="createTaskModal"
      :task="task"
      :options="options"
      :defineQuery="defineQuery"
      :team_session="team_session"
      @addTag="addTag"
      @closeModal="setCreateTaskModal(false)"
      @taskCreated="taskCreated()"
    />

    <DuplicateTaskComponent
      v-if="showDuplicateModal"
      :task="task_duplicate"
      @clearDuplicateTask="showDuplicateModal = false"
    />

    <ViewTaskModal
      v-if="task_view"
      :task="task_view"
      @closeModal="task_view = null"
    />
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'
import TitleCustom from '@/components/admin/partials/TitleCustom'
import TaskEditModal from '@/components/admin/task/TaskEditModal'
import ViewTaskModal from '@/components/admin/task/ViewTaskModal'
import MultiSelect from '@/components/assets/MultiSelect/MultiSelect'
import CreateTaskModal from '@/components/admin/task/CreateTaskModal'
import DuplicateTaskComponent from '@/components/admin/task/DuplicateTaskComponent'
import HoursTasksComponent from '@/components/admin/task/HoursTasksComponent'

import { handleDateClass } from '@/services/DateClass'
import { todayFormat } from '@/services/TodayFormat'

export default {
  name: 'AdminTaskComponent',
  data() {
    return {
      loading: false,
      boxedit: false,
      task: this.defineTask(),
      task_current: null,
      task_duplicate: {},
      filter: this.clearFilter(),
      account_session: null,
      auth_session_account: null,
      team_session: null,
      showDuplicateModal: false,
      task_view: null,
      tasks_by_finish: 0,
      today: null,
      options: [],
      createTaskModal: false,
      completed_tasks: false,
      clic_taskspendingauth: false,
    }
  },
  async beforeMount() {
    const routeQuery = this.$route.query
    const accountSession = routeQuery.account
      ? routeQuery.account
      : localStorage.session_account
    this.SESSION_ACCOUNT(accountSession)

    if (this.$route.path === '/admin/pendings-tasks') {
      this.account_session = null
    } else {
      this.account_session = accountSession
      localStorage.session_account = accountSession
    }

    this.auth_session_account = accountSession
    this.team_session = localStorage.session_team

    try {
      let query = this.defineQuery()

      const { list } = await this.getListTasksMongo(['task', query])
      const taskId = parseInt(this.$route.query.task)

      if (taskId) {
        const task = list.find((x) => x.id === taskId)

        if (task) {
          this.editTask(task)
        }
      }
    } catch (error) {
    } finally {
      this.loading = true
    }

    await Promise.all([this.getList('taskstate'), this.getList('user')])

    //this.$router.replace(this.$route.path)
  },
  mounted() {
    this.today = todayFormat()
  },

  methods: {
    defineTask() {
      return {
        name: '',
        date: '',
        campaign_id: '',
        team_id: '',
        entity: 'task',
        path: [],
        project_id: '',
      }
    },
    setCreateTaskModal(boolean) {
      this.createTaskModal = boolean
    },
    taskCreated() {
      this.task = this.defineTask()
      this.createTaskModal = false
    },
    taskEdited() {
      this.loading = false
      this.task = this.defineTask()
      this.boxedit = false
      window.location = window.location.href.split('?')[0]
    },
    clearFilter() {
      return {
        state: null,
        slug: '',
        date: null,
        name: null,
        created_by: null,
        support: true,
        assigned_to_me: false,
        start_date: null,
        end_date: null,
      }
    },
    defineQuery() {
      let completed_tasks = this.completed_tasks ? 'completed' : 'default'

      let query = `account_session=${this.account_session}&team_session=${this.team_session}&states=${completed_tasks}`

      let accountsLength = this.usersession.accounts
        ? this.usersession.accounts.length
        : null

      if (
        this.$route.path === '/admin/pendings-tasks' &&
        this.account_session == null &&
        accountsLength
      ) {
        query = `account_session=${this.usersession.accountsIds}&team_session=${this.team_session}&states=pending`
      }

      return query
    },
    async editTask(value) {
      this.boxedit = false
      window.scrollTo(0, 0)

      this.boxedit = true
      let task
      if (value.task_id) {
        let data = {
          entity: 'task',
          id: value.task_id,
        }
        const task_show = await this.show(data)
        task = { ...task_show }
      } else {
        task = JSON.parse(JSON.stringify(value))
      }
      if (task.response_path) {
        task.response_path = task.response_path.split(',')
      }
      this.task_current = task
    },
    async viewTask(task) {
      let view = {
        entity: 'taskversion',
        id: task.id,
      }
      task.versions = await this.show(view)

      this.task_view = task
    },
    closeEditTask() {
      this.boxedit = false
      this.task_current = null
    },
    createDuplicateModal(task) {
      this.showDuplicateModal = true
      task.user_id = null
      this.task_duplicate = task
    },
    viewAccountTask(e) {
      const { project_account_id } = e.campaign_attribute
      localStorage.session_account = project_account_id
      this.$router.push(
        `/admin/tasks?task=${e.id}&account=${project_account_id}`
      )
    },
    viewAccounts(val) {
      let query = ''
      let pending = ''

      if (this.$route.path === '/admin/pendings-tasks') {
        pending = 'pending'
      }

      if (val == 'all') {
        query = `account_session=${this.usersession.accountsIds}&team_session=${this.team_session}&states=${pending}`
        this.account_session = null
      } else {
        this.account_session = localStorage.session_account
        query = `account_session=${this.account_session}&team_session=${this.team_session}&states=${pending}`
      }

      try {
        this.getListTasksMongo(['task', query])

        this.loading = true
      } catch (error) {}
    },
    viewTaskFinish() {
      this.completed_tasks = !this.completed_tasks

      let query = ''
      query = this.defineQuery()

      try {
        this.getListTasksMongo(['task', query])

        this.loading = true
      } catch (error) {}
    },
    addTag(newTag) {
      this.options.push(newTag)
      this.task.path.push(newTag)
    },
    dateClass(task) {
      return handleDateClass('task', task, this.today)
    },
    taskPendingAuth() {
      var current = this.clic_taskspendingauth
      if (!current) {
        this.filter.state = 7
        this.filter.created_by = this.usersession.id
      } else {
        this.filter = this.clearFilter()
      }
      this.clic_taskspendingauth = !current
    },
    removeSupport() {
      this.filter.support = !this.filter.support
    },
    assignedToMe() {
      this.filter.assigned_to_me = !this.filter.assigned_to_me
    },
    ...mapMutations(['SESSION_ACCOUNT']),
    ...mapActions(['show', 'getAll', 'getList', 'getListTasksMongo']),
  },
  computed: {
    ...mapGetters({
      tasks: 'getTasks',
      users: 'getUsers',
      usersession: 'getUser',
      states: 'getTaskStates',
    }),
    filteredTasks() {
      let count = 0
      let tasksFiltered = this.tasks.filter((item) => {
        if (this.$route.path === '/admin/pendings-tasks') {
          if (item.state_id <= 3 || item.state_id == 6) {
            let support = this.filter.support
              ? true
              : item.campaign_attribute.project_account_id != 44

            let assigned_to_me = this.filter.assigned_to_me
              ? item.user_id == this.usersession.id
              : true
            return item && support && assigned_to_me
          }
        } else {
          let slug = this.filter.slug
            ? item.slug.toLowerCase().includes(this.filter.slug.toLowerCase())
            : true
          let name = this.filter.name
            ? item.name.toLowerCase().includes(this.filter.name.toLowerCase())
            : true
          let date = this.filter.date ? this.filter.date == item.date : true
          let state = this.filter.state
            ? this.filter.state == item.state_id
            : true

          let created_by = this.filter.created_by
            ? this.filter.created_by == item.created_by
            : true
          let start_date = this.filter.start_date
            ? this.filter.start_date + ' 00:00:01' <= item.created_at
            : true
          let end_date = this.filter.end_date
            ? this.filter.end_date + ' 23:00:00' >= item.created_at
            : true

          // validate tasks by finish
          if (item.state_id == 7 && item.created_by == this.usersession.id) {
            count++
          }

          return (
            slug &&
            name &&
            date &&
            state &&
            created_by &&
            start_date &&
            end_date
          )
        }
      })

      this.tasks_by_finish = count

      return tasksFiltered
    },
    filteredUsers() {
      return this.users.filter((item) => {
        var accounts_ids = item.accountsIds
        var search = accounts_ids.indexOf(parseInt(this.account_session))

        return search !== -1
      })
    },
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
    appTitleCustom: TitleCustom,
    DuplicateTaskComponent,
    ViewTaskModal,
    TaskEditModal,
    HoursTasksComponent,
    MultiSelect,
    CreateTaskModal,
    handleDateClass,
    todayFormat,
  },
}
</script>



// WEBPACK FOOTER //
// TaskComponent.vue?3b1a282a